
var FriendPvpActivityGetTicketPanel = xClass("FriendPvpActivityGetTicketPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/panel_pvp2_panel_ticket.csb")
})

FriendPvpActivityGetTicketPanel.show = function (ticketInfo, callback) {
    var panel = FriendPvpActivityGetTicketPanel.create(ticketInfo, callback);
    panel.popup(true);

    return panel;
}

FriendPvpActivityGetTicketPanel.prototype.ctor = function (info, callback) {
    var self = this;
    BasePanel.prototype.ctor.call(self);

    var adCount = info.adCount;
    var ticketInfo = info.ticketInfo;

    self.adCb = callback;

    self.getChildByName("txt").x += 20;
    var buyBtn = self.getChildByName("btn_coins");
    var coin = ticketInfo[1].coin;
    coin = coin.split(":")[1];
    buyBtn.getChildByName("num").setString(coin);
    quickBuildUIBUtton(buyBtn, () => {
        DCAssist.userTrack("PVP", "click_buy_tickets", {"abtest":"new"});
        self.buyTicket()
    })
    var freeBtn = self.getChildByName("btn_free");
    freeBtn.getChildByName("label").x += 15;
    quickBuildUIBUtton(freeBtn, () => {
        if (adCount > 0){
            self.showAd()
        }else{
            Toast.make(getText("error.tip.761310"));
        }
    })
    DCAssist.dc4User101("PVP","ad_button_show",{session: `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`})
    
    var closeBtn = self.getChildByName("btn_close");
    quickBuildUIBUtton(closeBtn, () => {
        self.onClose()
    })
}

FriendPvpActivityGetTicketPanel.prototype.showAd = function(){
    var self = this;
    if (self.isBusy){
        return;
    }
    DCAssist.dc4AdClick("PVP", "ad_get_pvp_tickets_click", {"abtest":"new"});
    self.isBusy = true;
    var snsProxy = require("clover/sns/SnsProxy").getInstance();
    snsProxy.showAd("PVPTicket")
    .then(isEnd=> {
        if (isEnd) {
            DCAssist.dc4AdFinish("PVP", "ad_get_pvp_tickets_finish", {"abtest":"new"});
            var onSuccess = function(evt){
                self.isBusy = false;
                self.adCb(evt.data);
                var rewards = new Array();
                rewards.push({"itemId":34, "num":1});
                var GetRewardsPanel = require("clover/panel/GetRewardsPanel");
                GetRewardsPanel.show(null, rewards, true, null, true);
                self.onClose();
            }
            var onFail = function(evt){
                self.isBusy = false;
                cc.error(evt);
            }
            var http = GainPvpAdCountHttp.new();
            http.addEventListener(Events.kComplete, onSuccess);
            http.addEventListener(Events.kError, onFail);
            http.addEventListener(Events.kCancel, onFail);
            http.load();
        } else {
            DCAssist.dc4AdDropOut("PVP", "ad_get_pvp_tickets_dropout", {"abtest":"new"});
            self.isBusy = false;
            Toast.make(getText("error.tip.dropout_ad"));
        }
    })
    .catch(err=> {
        DCAssist.dc4AdNoMore("PVP", "ad_get_pvp_tickets_noAds", {"abtest":"new"});
        self.isBusy = false;
        Toast.make(getText("video.ad.error"));
        cc.error("wx_video_ad : " + err.errMsg);
    })
}

FriendPvpActivityGetTicketPanel.prototype.buyTicket = function(){
    var self = this;
    if (self.isBusy){
        return;
    }
    self.isBusy = true;
    function onSuccess(evt) {
        var data = {adTicketCount2:3};
        self.adCb(data);
        var rewards = new Array();
        rewards.push({"itemId":34, "num":3});
        var GetRewardsPanel = require("clover/panel/GetRewardsPanel");
        GetRewardsPanel.show(null, rewards, true, null, true);
        self.onClose();
    }
    function onFail(event) {
        if (event.data === ZooErrorCode.CASH_NOT_ENOUGH) {
            require("clover/panel/CashNotEnoughPanel").show(function () {
                // require("clover/panel/MarketPanel")
                // MarketPanel.show(MarketPanelTabId.kCashTab)
                self.isBusy = false
            }, function () {
                self.isBusy = false
            })
        } else {
            self.isBusy = false;
            Toast.make(getText("error.tip." + tostring(event.data)))
        }
    }
    function onCancel() {
        self.isBusy = false;
    }
    // var energyGoodsId = MetaManager.getInstance().getGoodMetaByItemID(GamePropIds.kTicketX3).id;
    // UserDeal.getInstance().buyGoods(energyGoodsId, 0, UserDealPayType.kCash, null, null, onSuccess, onFail, onCancel, ModuleName.PVP_TICKET)
    // item表里票子ID是8，对应34
    UserDeal.getInstance().buyItem(8, 1, UserDealPayType.kCash, null, null, onSuccess, onFail, onCancel, ModuleName.PVP_TICKET)
}

FriendPvpActivityGetTicketPanel.prototype.onCleanup = function() {
    ResManager.release(["packed/PvpGetTicketRes.pack"]);
}

FriendPvpActivityGetTicketPanel.prototype.popup = function () {
    var self = this
    var targetScale = self.getScale()
    self.setScale(0)
    var time = 7 / 30
    PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
    var vSize = cc.Director.getInstance().getVisibleSize();
    var dH = display.height-GamePlayConfig_Design_Height;
    var targetPos = cc.pAdd(cc.p(self.getPosition()), cc.p(70, 900 + dH/2));
    var pos_O = cc.p(vSize.width / 2, vSize.height / 2)
    var startPoint = cc.pMul(cc.pSub(targetPos, pos_O), 0.23)
    self.setScale(0.23)
    self.setPosition(cc.p(pos_O.x + startPoint.x, pos_O.y + startPoint.y))
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))))
    return self
}

module.exports = FriendPvpActivityGetTicketPanel